// extracted by mini-css-extract-plugin
module.exports = {"root":"zqO8Q","bg":"_1eDCt"};